import { apiRequest, apiGETRequest } from "../utility/Utility";

export const samples = async (visit_id) => {
  return apiGETRequest({
    endpoint: "/samples",
    payload: { visit_id },
  });
};

export const updateSample = async (dataArray) => {
  return apiRequest({
    endpoint: "/samples/update-sample",
    payload: {
      samples: dataArray,
    },
  });
};

export const createSample = async (data, visit_id) => {
  return apiRequest({
    endpoint: "/samples/new-sample",
    payload: { ...data, visit_id },
  });
};

export const removeSample = async (
  id,
  reason,
  email,
  pws_id,
  well_id,
  visit_id
) => {
  return apiRequest({
    endpoint: "/samples/remove-sample",
    payload: { id, reason, email, pws_id, well_id, visit_id },
  });
};

export const getSamplesDataForCOC = async (visit_id) => {
  return apiGETRequest({
    endpoint: "/samples/coc",
    payload: { visit_id },
  });
};
